'use client';

import { useEffect, useState } from 'react';
import { Hero } from '@/components/sections/hero';
import { Collections } from '@/components/sections/collections';
import { Scenarios } from '@/components/sections/scenarios';
import { Story } from '@/components/sections/story';
import { Reasons } from '@/components/sections/reasons';
import { Faq } from '@/components/sections/faq';
import { JsonLd } from '@/components/json-ld';
import { SiteNav } from '@/components/site-nav';
import { Footer } from '@/components/sections/footer';
import { I18nProvider } from '@/i18n/provider';
import type { Locale } from '@/i18n/config';
import { defaultLocale, isLocale } from '@/i18n/config';

function getInitialLocale(): Locale {
  if (typeof document === 'undefined') return defaultLocale;
  const saved = document.cookie
    .split('; ')
    .find((row) => row.startsWith('NEXT_LOCALE='))
    ?.split('=')[1];
  if (saved && isLocale(saved)) return saved;
  return defaultLocale;
}

export default function HomePage() {
  const [locale, setLocale] = useState<Locale>(defaultLocale);
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setLocale(getInitialLocale());
    setMounted(true);
  }, []);

  return (
    <I18nProvider initialLocale={locale}>
      <SiteNav />
      <main>
        <JsonLd />
        <Hero />
        <Collections />
        <Scenarios />
        <Story />
        <Reasons />
        <Faq />
      </main>
      <Footer />
      <div style={{ display: 'none' }} suppressHydrationWarning>
        {mounted ? locale : ''}
      </div>
    </I18nProvider>
  );
}
